/*
Selectors:
Allowing our compoenets to accurately get data out of the state
*/

export const getnumberOfClicks = state => state.numberOfClicks;
export const getOtherProps = state => state.otherProp;
export const getGlobalProps = state => state.appGlobal;

